/** Permissões criadas com a multi-tenancy (V4 e V5 dos schemas dos tenants); só o papel `admin` as tem. */
export const TENANCY_PERMISSIONS = {
  CAN_REMOVE_USER_FROM_ORGANIZATION: "CAN_REMOVE_USER_FROM_ORGANIZATION",
  CAN_GET_FILE_USAGE: "CAN_GET_FILE_USAGE",
} as const;
